var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsInt, IsOptional, IsString, Matches, Min } from 'class-validator';
import { CALENDAR_DATE } from './calendar-date.js';
/**
 * Body of
 * `POST /v1/office-locations/:officeLocationId/abrechnungsbeauftragung/acceptances`
 * (#1613).
 *
 * The same endpoint for the first acceptance and for accepting a newer version:
 * both are the same process — a practice accepts a version — and the difference
 * is whether a record already stands.
 */
export class AcceptAbrechnungsbeauftragungDto {
    /** The number from the terms-version registry. Has to exist and be newer than the accepted one. */
    termsVersion;
    /**
     * First covered day, inclusive, `YYYY-MM-DD`, today or later.
     *
     * ⚠ **Only on the first acceptance.** Whoever accepts a newer version and
     * nevertheless sends a date is refused rather than silently ignored: the
     * `effectiveFrom` stays put across a version change, and a silently discarded
     * field would look to the practice like a moved beginning.
     */
    effectiveFrom;
}
__decorate([
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], AcceptAbrechnungsbeauftragungDto.prototype, "termsVersion", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Matches(CALENDAR_DATE, { message: 'effectiveFrom must be formatted YYYY-MM-DD.' }),
    __metadata("design:type", String)
], AcceptAbrechnungsbeauftragungDto.prototype, "effectiveFrom", void 0);
//# sourceMappingURL=accept-abrechnungsbeauftragung.dto.js.map